/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ChangeEmail
 */
export interface ChangeEmail {
  /**
   *
   * @type {string}
   * @memberof ChangeEmail
   */
  password: string;
  /**
   *
   * @type {string}
   * @memberof ChangeEmail
   */
  email?: string;
}

/**
 * Check if a given object implements the ChangeEmail interface.
 */
export function instanceOfChangeEmail(value: object): value is ChangeEmail {
  if (!('password' in value) || value['password'] === undefined) return false;
  return true;
}

export function ChangeEmailFromJSON(json: any): ChangeEmail {
  return ChangeEmailFromJSONTyped(json, false);
}

export function ChangeEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeEmail {
  if (json == null) {
    return json;
  }
  return {
    password: json['password'],
    email: json['email'] == null ? undefined : json['email'],
  };
}

export function ChangeEmailToJSON(value?: ChangeEmail | null): any {
  if (value == null) {
    return value;
  }
  return {
    password: value['password'],
    email: value['email'],
  };
}
